import React from "react";

interface EditConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const EditConfirmationModal: React.FC<EditConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      {/* Gradient Border Wrapper */}
      <div
        className="relative w-full mx-4"
        style={{
          maxWidth: "820px",
          borderRadius: "40px",
          padding: "1px",
          background:
            "linear-gradient(180deg, rgba(130,135,152,0) 0%, rgba(130,135,152,0.4) 100%)",
        }}
      >
        {/* Modal */}
        <div
          className="relative bg-[#0e0e10] overflow-hidden"
          style={{
            borderRadius: "40px",
            padding: "64px 0",
          }}
        >
          {/* Top glow */}
          <div
            className="absolute left-1/2 -translate-x-1/2 blur-3xl opacity-80"
            style={{
              top: "-70px",
              width: "480px",
              height: "150px",
              background:
                "linear-gradient(226deg, #1B76FF 12%, #2BFAA3 94%)",
            }}
          />

          {/* Content */}
          <div className="relative z-10 px-[72px] ">
            <h2 className="text-[#FFFFFF] text-center text-[32px] font-semibold">
              Heads Up!
            </h2>

            <div className="mt-6 space-y-4 text-[20px] leading-[160%] text-white/75">
              <p>
                Please note that once a campaign is published, only the artist
                name, title, and budget can be edited.
              </p>

              <p>
                After making your changes, remember to republish the campaign
                to take effect.
              </p>

              <p>
                Meta Ads may take a few hours and in rare cases, a few days – to
                review your campaign before it becomes active again!
              </p>
            </div>

            {/* Buttons */}
            <div className="mt-10 flex justify-center gap-5">
              {/* Secondary Button */}
              <button
                onClick={onCancel}
                className="h-[48px] px-8 rounded-full bg-white text-[#020202] text-[16px] font-semibold transition "
              >
                Never mind, no edits needed
              </button>

              {/* Primary Button */}
              <div
                className="rounded-full p-[1px]"
                style={{
                  background:
                    "linear-gradient(90deg, rgba(88, 242, 169, 0.2) 0%, #58F2A9 100%)",
                }}
              >
                <button
                  onClick={onConfirm}
                  className="h-[48px] px-8 rounded-full text-white text-[16px] font-semibold transition"
                  style={{
                    background: "linear-gradient(to right, #1C3941, #58F2A9)",
                  }}
                >
                  Proceed with the edits
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditConfirmationModal;
